/**
 * Created By Elia Rohana on 2/13/19
 */
import { Action } from '@ngrx/store';
import { PathwaysAuthoringState } from '@ispm/shared/constants/pathways-authoring-state';

export enum StateActionTypes {
    MODELER_STATE = '[bpmn modeler set state]'
}

export class SetModelerState implements Action {
    readonly type = StateActionTypes.MODELER_STATE;

    constructor(public payload: { modelerState: PathwaysAuthoringState }) {
    }
}

export type ModelerStateActions = SetModelerState;
